import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { showToast } from "../../utils/showToast";
import { useLazyQuery } from "@apollo/client";
import { GET_CARS, GET_RENTALS } from "../../apollo/operations";
import Loading from "../loading/Loading";
import { useDispatch, useSelector } from "react-redux";
import { RentalType } from "../../types";

import "aiprise-web-sdk";

// import { smartcar } from "../../api/smartCar";

import UserDetails from "./UserDetails.Dashboard";
import Analytics from "./Analytics.Dashboard";
import ActiveRental from "./ActiveRental.Dashboard";
import Banners from "./Banners.Dashboard";
import RentalHistory from "./RentalHistory";
import {
  setLesseeRentals,
  setLessorRentals,
  setVehicles,
} from "../../redux/slices/dashboardSlice";
import { RootState } from "../../redux/store";

type pageOption = "Rented Vehicles" | "Listed Vehicles";

type DashboardProps = {
  isVerified: boolean;
};

const Dashboard: React.FC<DashboardProps> = ({ isVerified }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const user = useSelector((state: RootState) => state.user.userDetails);

  const type = useSelector(
    (state: RootState) => state.dashboardState.dashboardType
  );

  // useEffect(() => {
  //   if (!user) {
  //     navigate("/auth");
  //   }
  // });

  // const handleClick = () => {
  //   if (!isVerified) {
  //     showToast("Please your identity verification to continue", "error");
  //     return;
  //   } else {
  //     navigate("/vehicles/add");
  //   }
  // };

  const [activeRental, setActiveRental] = useState<string>("");
  // const [lesseeRentals, setLesseeRentals] = useState<RentalType[]>([]);
  // const [lessorRentals, setLessorRentals] = useState<RentalType[]>([]);
  // const [vehicles, setVehicles] = useState<VehicleType[]>([]);

  const [getLesseeRentals, { loading, data }] = useLazyQuery(GET_RENTALS, {
    variables: {
      orderBy: [
        {
          createdAt: "Desc",
        },
      ],
      where: {
        lessee: {
          id: user?.id,
        },
      },
    },
    onCompleted: (data) => {
      // console.log("lessor", data.rentals);
      const activeRental = data.rentals.find(
        (rental: RentalType) =>
          rental.rentalStatus === "Active" ||
          (rental.rentalStatus === "Booked" &&
            new Date(rental.rentalStartDatetime) <=
              new Date(new Date().getTime() + 5 * 60 * 60 * 1000))
      );
      if (activeRental) {
        setActiveRental(activeRental.id);
      }
      // setLesseeRentals(data.rentals);
      dispatch(setLesseeRentals(data.rentals));
    },
    onError: (error) => {
      // console.log(error);
      if (error.message === "Unauthorized") {
        showToast("Please login to continue", "error");
        navigate("/auth");
        return;
      }

      showToast(error.message, "error");
      // TODO: redirect to login page
      // navigate("/auth");
    },
  });

  const [getLessorRentals, { loading: lessorRentalLoading }] = useLazyQuery(
    GET_RENTALS,
    {
      variables: {
        orderBy: [
          {
            createdAt: "Desc",
          },
        ],
        where: {
          lessor: {
            id: user?.id,
          },
        },
      },
      onCompleted: (data) => {
        // console.log("lessee", data.rentals);
        dispatch(setLessorRentals(data.rentals));
      },
      onError: (error) => {
        // console.log(error);
        if (error.message === "Unauthorized") {
          showToast("Please login to continue", "error");
          navigate("/auth");
          return;
        }

        showToast(error.message, "error");
        // TODO: redirect to login page
        // navigate("/auth");
      },
    }
  );

  const [getCars, { loading: loadingCars }] = useLazyQuery(GET_CARS, {
    variables: {
      where: {
        lessor: {
          id: user?.id,
        },
        web3Data: {
          isSet: true,
        },
      },
      orderBy: [
        {
          createdAt: "Desc",
        },
      ],
    },
    onCompleted(data) {
      // console.log(data?.cars);
      dispatch(setVehicles(data?.cars));
    },
    onError: (error) => {
      // console.log(error);

      showToast(error.message, "error");
      // TODO: redirect to login page
      // navigate("/auth");
    },
  });

  useEffect(() => {
    if (user) {
      getLesseeRentals();
      getLessorRentals();
      getCars();
    }
  }, [user]);

  // React.useEffect(() => {
  //   if (page === "Rented Vehicles") {
  //     rentalRefetch();
  //   }
  //   if (page === "Listed Vehicles") {
  //     carRefetch();
  //   }
  // }, [page]);

  // getDistanceTest().then((res) => {
  //   console.log(res);
  // });

  // smartcar.addClickHandler({ id: "smart-car-connect" });

  // smartcar.addClickHandler({ id: "smart-car-connect" });

  // console.log(smartcar);

  if (loading || lessorRentalLoading || loadingCars)
    return <Loading loading={loading || lessorRentalLoading || loadingCars} />;

  return (
    <div className=" bg-[#F6F7F9] min-h-screen w-[80%] mx-auto ">
      <div className="w-full py-10 px-5 flex flex-col gap-7 mx-auto ">
        <UserDetails />
        <Banners />
        {data && activeRental && type === "lessee" && (
          <ActiveRental rentalId={activeRental} />
        )}
        {/* {type === "lessor" && <VehicleDetails />} */}
        <Analytics />
        <RentalHistory />
      </div>
    </div>
  );
};

export default Dashboard;

// <div className=" h-full w-[90%] pt-20 flex flex-col-reverse gap-5 lg:flex-row justify-between mx-auto">
//   <div className="w-full lg:w-[40%] xl:w-[35%] flex flex-col gap-4 px-3 py-7 bg-[#F8F7F1] ">
//     <div className="flex flex-col gap-2 p-3">
//       <h2 className=" font-Inter text-xl font-medium text-[#535256] ">
//         Rented Vehicles
//       </h2>
//       {rentals.length > 1 ? (
//         <p className=" font-Inter text-sm font-normal text-[#a3a3a3] ">
//           Below are the list of the vehicles you've rented
//         </p>
//       ) : (
//         <p className=" font-Inter text-sm font-normal text-[#a3a3a3] ">
//           Your list of rented vehicles will be displayed here once you've
//           completed a rent
//         </p>
//       )}
//     </div>
//     {rentals &&
//       rentals.map((rental, index) => (
//         <RentalCard rental={rental} index={index} key={index} />
//       ))}
//   </div>
//   <div className="w-fit">
//     <div
//       className="cursor-pointer flex hover:bg-white gap-2 items-center p-3 rounded-[10px] bg-[#F8F7F1]"
//       onClick={handleClick}
//     >
//       <img src={hireLocation} alt="" className="p-1 " />
//       <span className="text-[12px] font-semibold leading-4 font-Jakarta ">
//         List your vehicle on the marketplace
//       </span>
//     </div>
//   </div>
// </div>
